<!-- Integer input - only numbers allowed -->
<input 
  *ngIf="isIntegerInput()"
  class="form-control" 
  type="number"
  [placeholder]="getPlaceholder()"
  [(ngModel)]="value"
  [disabled]="disabled" />

<!-- String input - free text allowed -->
<input 
  *ngIf="isStringInput()"
  class="form-control" 
  type="text"
  [placeholder]="getPlaceholder()"
  [(ngModel)]="value"
  [disabled]="disabled" />

<!-- Invisible input - hidden from user -->
<input 
  *ngIf="isInvisible()"
  class="form-control" 
  type="text"
  [placeholder]="getPlaceholder()"
  [(ngModel)]="value"
  [disabled]="disabled"
  readonly
  style="background-color: #f5f5f5; cursor: not-allowed;" />

<!-- Boolean input - True option -->
<div class="c-radio" *ngIf="isBooleanInput()">
  <label>
    <input 
      type="radio" 
      name="radioBoolValue_{{dataType}}"
      [checked]="isValueTrue()"
      (change)="setValueToTrue()"
      [disabled]="disabled" />
    <span class="fa fa-circle"></span>True
  </label>
</div>

<!-- Boolean input - False option -->
<div class="c-radio" *ngIf="isBooleanInput()">
  <label>
    <input 
      type="radio" 
      name="radioBoolValue_{{dataType}}"
      [checked]="isValueFalse()"
      (change)="setValueToFalse()"
      [disabled]="disabled" />
    <span class="fa fa-circle"></span>False
  </label>
</div>

<!-- Dropdown for comma-separated default values -->
<select 
  *ngIf="isDropdownInput()"
  class="form-control" 
  [(ngModel)]="value"
  [disabled]="disabled">
  <option [ngValue]="null" disabled selected>{{getPlaceholder()}}</option>
  <option *ngFor="let option of getDropdownOptions()" [ngValue]="option">{{option}}</option>
</select>

